module.exports = __webpack_public_path__ + "img/img_home_case_7.1aa26e0f.png";